<template>
    <transition name="modelMask">
      <div class="modal-mask" v-show="payModal">
        <div class="modal-wrapper" >
          <div class="modal-container">
            <div class="modal_header">
              <slot name="header">
                <span class="fs18">{{title}}</span>
              </slot>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" @click="handleClose">×</span>
              </button>
            </div>
            <div class="modal_body">
              <slot name="body">
                  <template v-if="payStatus == 1">
                    <div slot="body">
                      <div>
                        <div class="modal_body_title">旗舰版</div>
                        <div class="">
                          <div class="modal_body_bg">
                            <div>12个月</div>
                            <div><span class="fs16">￥</span>{{money02}}</div>
                            <div>￥41.66/月</div>
                          </div>
                        </div>
                        <div class="modal_body_select">
                          <select v-model="couponId" @change="changeCoupon">
                            <option :value="item.id" v-for="(item, index) in couponList" :key="index"> {{item.name}}</option>
                          </select>
                        </div>
                        <div class="payment_money">
                            <div><span class="">￥</span>{{actualPay}}</div>
                            <div class="payment_money_detail" v-if="couponMoney>0">已优惠<span>{{couponMoney}}</span> 元，仅需<span>{{actualAveragePay}}</span> 元/月</div>
                        </div>
                        <!-- <div class="modal_body_button" @click="toPay">立即支付</div> -->
                        <div class="payment_qr_box_content6"> 
                          <div @click="choice(10)">支付宝</div>
                          <div @click="choice(11)">微信</div>
                        </div>
                        <div class="has_order" v-if="hasOrderShow">存在待支付订单，<span @click="toCheck">立即查看</span></div>
                      </div>
                    </div>
                  </template>
                  <template v-else-if="payStatus == 2">
                    <div>
                      <div class="to-back" @click="toback">返回</div>
                      <div class="remain_wrapper">剩余{{paramsTime.m>=0?paramsTime.m:0}}分：{{paramsTime.s>=0?paramsTime.s:0}}秒自动关闭</div>
                      <div class="payment_qr_box">
                        <div class="payment_qr_box_content1">支付金额: <span>￥{{actualPay}}</span> (券已减￥<span>{{couponMoney}}</span>)</div>
                        <div>交易订单：{{orderObj.orderNo}} </div>
                        <div>购买物品：{{orderObj.object}} </div>
                        <div class="payment_qr_box_content4">
                          <img :src="orderObj.qrCodeUrl"/>
                        </div>
                        <div class="payment_qr_box_content5">
                          <span>{{buyTltle}}</span>
                        </div>
                        <!-- <div class="payment_qr_box_content6"> 
                          <div @click="choice(10)">支付宝</div>
                          <div @click="choice(11)">微信</div>
                        </div> -->
                      </div>
                    </div>
                  </template>

              </slot>
            </div>

            <div class="modal_footer">
              <slot name="footer">
                <!-- <button class="btn btn-secondary" @click="handleClose">取消</button> -->
                <!-- <button type="button" class="btn btn-primary">确定</button> -->
              </slot>
            </div>
          </div>
        </div>
      </div>
  </transition>

</template>

<script>
import {
  getPayQrCode,
  getUserPayOrderStatus,
  getCouponList,
  getUnPayQrCode,
} from '@/api/api'

import { mapGetters, mapActions } from "vuex";

export default {
  name: "pcPayment",
  props: {
    payModal: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '订单信息'
    },
    pCouponId:{
      type:String,
      default: '0'
    }
    
  },
  data() {
    return {
      couponId:'0',
      couponList: [
        { name: '不使用优惠券' , id: '0', amount:'0'}
      ],
      payShow: false,
      buyType: 10, // 10支付宝11微信
      buyTltle: '请使用支付宝APP扫码完成支付',
      money02:500,
      orderObj: {
        
      },
      timer:null,
      actualPay:0,
      couponMoney:0,
      actualAveragePay:0,
      payStatus:1,
      timerId:null,
      time02:180,
      paramsTime:{},
      hasOrderShow:false,   // 是否存在未支付订单0否1是
    };
  },
  watch:{
    payModal(val){
      if(val){
        //document.documentElement.style.overflowY = 'hidden'; 
        document.body.style.overflow = 'hidden';
        this.payStatus = 1;
        this.getCouponList();
      }else{
        //document.documentElement.style.overflowY = 'scroll'; 
        document.body.style.overflow = 'scroll';
      }
    },
    pCouponId:{
      handler(nV,oV){
        this.couponId = nV
        if (this.couponId != '0') {
          let timer = setTimeout(() => {
            this.changeCoupon()
            clearTimeout(timer)
          }, 500);
        }else{

        }
      },
      // deep: true,
      // immediate:true
    }
  },
  mounted(){
    this.actualPay = this.numFormat(this.money02-this.couponMoney);
  },
  methods: {
    //倒计时
    downTime(startTimes,minutes){
      let u = navigator.userAgent;
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); 
      let newTime = new Date().getTime();
      let startTime;
      if(isiOS){
        startTimes = startTimes.replace(/\-/g, "/");
        startTime = new Date(startTimes).getTime() || new Date().getTime();    //获取当前时间的毫秒值
      }else{
        startTime = new Date(startTimes).getTime() || new Date().getTime();    //获取当前时间的毫秒值
      }
      
      let endTime =  startTime+minutes*60*1000;         //根据倒计时分钟计算结束时间的毫秒值
      let time = Math.floor((endTime - newTime)/1000)
      this.timerId = setInterval(()=>{
        time--;
        // 把时间转换成天-时-分-秒
        var m = Math.floor( time/60%60);
        var s = Math.floor( time%60);
      
        if(time <= 0){
          clearInterval(this.timerId)
          clearInterval(this.timer)
          this.payStatus =1;
          this.$emit('payClose')
          this.$emit('update:payShow', false)
        }
        
        let paramsTime={
          m:m,
          s:s
        }
        this.paramsTime = paramsTime;
      },1000)
      
    },
    handleClose() {
      this.$emit('payClose')
      this.$emit('update:payShow', false)
      clearInterval(this.timerId)
      clearInterval(this.timer)
      this.hasOrderShow = false;
      //this.payStatus =1;
    },
    toback(){
      this.getCouponList();
      clearInterval(this.timerId)
      clearInterval(this.timer)
      this.payStatus =1;
    },
    toPay(){
      clearInterval(this.timerId)
      clearInterval(this.timer)
      this.getPayCode();
    },
    toCheck () {
      clearInterval(this.timerId)
      clearInterval(this.timer)
      let data = {
        type: this.buyType,
        couponId:this.couponId
      }
      getUnPayQrCode(data).then(res => {
        if (res.status == 200) {
          this.orderObj = res.body;
          if(res.body.flag){
            this.$toast({
              title: "成功",
              content: "支付成功",
              type: "success",
            });
            this.handleClose()
          }else{
            if(res.body.unPayOrderFlag){
              this.hasOrderShow = true;
              this.$toast({
                title: "提示",
                content: "存在待支付订单，立即查看",
                type: "warning",
              });
            }else{
              this.hasOrderShow = false;
              this.payStatus = 2;
              this.getUserPayOrderStatus()
              this.downTime(res.body.expirationTime,0)
            }
            
          } 
        }
      })
    },
    changeCoupon(){
      this.couponMoney =  (this.couponList.find(item => item.id === this.couponId) || {}).amount;
      this.actualPay = this.numFormat(this.money02-this.couponMoney);
      this.actualAveragePay = this.numFormat(this.actualPay/12)
    },
    choice (type) {
      this.buyType = type
      if (type == 10) {
        this.buyTltle = '请使用支付宝APP扫码完成支付'
      } else {
        this.buyTltle = '请使用微信APP扫码完成支付'
      }
      
      this.getPayCode()
    },
    getPayCode () {
      clearInterval(this.timerId)
      clearInterval(this.timer)
      let data = {
        type: this.buyType,
        couponId:this.couponId
      }
      getPayQrCode(data).then(res => {
        if (res.status == 200) {
          this.orderObj = res.body;
          if(res.body.flag){
            this.$toast({
              title: "成功",
              content: "支付成功",
              type: "success",
            });
            this.handleClose()
          }else{
            if(res.body.unPayOrderFlag){
              this.hasOrderShow = true;
              this.$toast({
                title: "提示",
                content: "存在待支付订单，立即查看",
                type: "warning",
              });
            }else{
              this.hasOrderShow = false;
              this.payStatus = 2;
              this.getUserPayOrderStatus();
              this.downTime(res.body.expirationTime,0)
            }
            
          } 
        }
      })
    },
    getCouponList(){
      // let defaultArr = [{ name: '不使用优惠券' , id: '0', amount:'0'}];
      getCouponList().then(res => {
        if (res.status == 200) {
          this.couponList= [{ name: '不使用优惠券' , id: '0', amount:'0'}, ...res.body]
        }
      })
    },
    getUserPayOrderStatus(){
      this.timer = setInterval(()=>{
        let params = {
          orderNo: this.orderObj.orderNo
        }
        getUserPayOrderStatus(params).then(res => {
          if (res.status == 200) {
            if(res.body){
              this.$toast({
                title: "成功",
                content: "支付成功",
                type: "success",
              });
              clearInterval(this.timerId)
              clearInterval(this.timer)
              this.handleClose()
            }
          }
        })
      },3000) 
    },
  },
  beforeDestroy(){
    clearInterval(this.timerId)
    clearInterval(this.timer)
  }
};
</script>

<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 520px;
  margin: 0px auto;
  /* padding: 20px 30px; */
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.modal_header {
    display: flex;
    -ms-flex-align: start;
    align-items: center;
    -ms-flex-pack: justify;
    justify-content: space-between;
    /* padding: 1rem 1rem; */
    padding: 15px 20px;
    /* border-bottom: 1px solid #dee2e6; */
    border-bottom: 1px solid #fff;
    border-top-left-radius: calc(0.3rem - 1px);
    border-top-right-radius: calc(0.3rem - 1px);
}
.modal_header .close {
    /* padding: 1rem 1rem;
    margin: -1rem -1rem -1rem auto; */
    padding: 20px 20px;
    margin: -20px -20px -20px auto;
}
button.close {
    padding: 0;
    background-color: transparent;
    border: 0;
    
}
.close {
    float: right;
    /* font-size: 1.5rem; */
    font-size: 28px;
    font-weight: 700;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    opacity: .5;
}
.modal_body {
  padding: 15px 20px;
  box-sizing: border-box;
  max-height: 500px;
  overflow-y: scroll;
  
}

::-webkit-scrollbar {
  display: none;
}
.modal_footer {
    padding: 15px;
    text-align: right;
    /* border-top: 1px solid #e5e5e5; */
    border: none;
}
.modal-default-button {
  float: right;
}

/*
 * the following styles are auto-applied to elements with
 * v-transition="modal" when their visiblity is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modelMask-enter, .modelMask-leave {
  opacity: 0;
}

.modelMask-enter .modal-container,
.modelMask-leave .modal-container {
  transform: scale(1.1);
}
.btn {
    display: inline-block;
    font-weight: 400;
    color: #212529;
    text-align: center;
    vertical-align: middle;
    user-select: none;
    background-color: transparent;
    border: none;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: 0.25rem;
    outline: none;
}
.btn-primary {
    color: #fff;
    background-color: #007bff;
    border-color: #007bff;
}
.btn-secondary {
    color: #fff;
    background-color: #6c757d;
    border-color: #6c757d;
}
.modal_footer .btn+.btn {
    margin-bottom: 0;
    margin-left: 10px;
}
.fs18 {
  font-size: 18px;
}

 .modal_body_title {
    color: #333333;
    font-family: PingFang SC;
    font-size: 24px;
    font-weight: 500;
    line-height: 36px;
    letter-spacing: 0px;
  }
  .modal_body_bg {
    margin-top: 10px;
    width: 190px;
    height: 150px;
    background-image: url("~@/assets/images/orderInfo_bg.png");
    background-position: center;
    background-repeat: no-repeat;
    border-radius:4px;
    padding: 16px 24px;
    box-sizing: border-box;
    color: #FFFFFF;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    &>div:nth-of-type(1) {
      font-size: 24px;
    }
    &>div:nth-of-type(2) {
      font-size: 44px;
    }
    &>div:nth-of-type(3) {
      font-size: 16px;
    }
  }
  .modal_body_select {
    margin-top: 16px;
    select {
      width: 100%;
      height: 40px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: flex-start;
      padding: 8px 16px 8px 16px;
      border: 1px solid #DDDDDD !important;
      border-radius:4px;
      font-size: 16px;
      font-weight: 400;
      border: none;
      color: #808DA1;
      option {
        padding: 5px;
        border: 1px solid #DDDDDD;
      }
    }
    select:focus-visible {
        outline: none;
    }
  }
  .payment_money {
    color: #6696FF;
    margin-top: 16px;
    font-size: 20px;
    font-weight: 500;
    line-height: 30px;
    .payment_money_detail {
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
      color: #666666;
      span {
        color: #E70000;
      }
    }
  }
  .modal_body_button {
    margin-top: 16px;
    height: 40px;
    background: #0069EA;
    border-radius:4px;
    color: #FFFFFF;
    font-family: PingFang SC;
    font-size: 16px;
    font-weight: 400;
    line-height: 40px;
    letter-spacing: 0px;
    text-align: center;
    cursor: pointer;
        
  }
  .remain_wrapper{
    color: red;
    text-align: center;
    margin: 8px 0;
  }
  .payment_qr_box_content6 {
    display: flex;
    align-items: center;
    justify-content: space-around;
    text-align: center;
    margin-top: 10px;
    & > div{
      width: 190px;
      height: 40px;
      color: #FFFFFF;
      font-size: 16px;
      font-weight: 400;
      line-height: 40px;
      border-radius:4px;
      cursor: pointer;
    }
    & > div:nth-of-type(1) {
      background: #0069EA;
    }
    & > div:nth-of-type(2) {
      background: #0FC200;
    }
  }
  .to-back{
    display: flex;
    justify-content: flex-end;
    font-size: 18px;
    color: rgb(128, 141, 161);
    margin-bottom: 12px;
    cursor: pointer;
  }
  .has_order{
    font-size: 14px;
    margin-top: 10px;
    span{
      color: #6696FF;
      cursor: pointer;
    }
  }
 // 二维码块
  .payment_qr_box {
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    color:#808DA1;
    .payment_qr_box_content1 {
      margin-bottom: 16px;
      color: #666666;
      span:nth-of-type(1) {
        font-size: 20px;
        font-weight: 500;
        color:#6696FF;
      }
      span:nth-of-type(2) {
        color:#E70000;
      }
    }
    .payment_qr_box_content4 {
        width: 220px;
        height: 220px;
        // border: 1px solid #f3f3f3;
        margin: 0 auto;
        img {
          width: 100%;
          height: 100%;
        }
    }
    .payment_qr_box_content5 {
      margin-bottom: 50px;
    }
    .payment_qr_box_content6 {
      display: flex;
      align-items: center;
      justify-content: space-around;
      & > div{
        width: 190px;
        height: 40px;
        color: #FFFFFF;
        font-size: 16px;
        font-weight: 400;
        line-height: 40px;
        border-radius:4px;
        cursor: pointer;
      }
      & > div:nth-of-type(1) {
        background: #0069EA;
      }
      & > div:nth-of-type(2) {
        background: #0FC200;
      }
    }
    .payment_qr_box_content7 {
      text-align: right;
      color: #6696FF;
      font-size: 18px;
      font-weight: 400;
      line-height: 26px;
      margin-bottom: 16px;
        cursor: pointer;
    }
  }

//  移动端
@media screen and (min-width: 300px) and (max-width: 768px) {
    
.modal-container {
  width: 90vw;
  margin: 0 auto;
  /* padding: 20px 30px; */
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.modal_header {
    display: flex;
    -ms-flex-align: start;
    align-items: center;
    -ms-flex-pack: justify;
    justify-content: space-between;
    /* padding: 1rem 1rem; */
    padding: 2rem 2.6667rem;
    /* border-bottom: 1px solid #dee2e6; */
    border-bottom: 1px solid #fff;
    border-top-left-radius: calc(0.3rem - 1px);
    border-top-right-radius: calc(0.3rem - 1px);
}
.modal_header .close {
    /* padding: 1rem 1rem;
    margin: -1rem -1rem -1rem auto; */
    padding: 2.6667rem 2.6667rem;
    margin: -2.6667rem -2.6667rem -2.6667rem auto;
}
button.close {
    padding: 0;
    background-color: transparent;
    border: 0;
    
}
.close {
    float: right;
    /* font-size: 1.5rem; */
    font-size: 7.4667rem;
    font-weight: 700;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    opacity: .5;
}
.modal_body {
  padding: 2rem 2.6667rem;
  box-sizing: border-box;
  max-height: 60vh;
  overflow-y: scroll;
  
}

::-webkit-scrollbar {
  display: none;
}
.modal_footer {
    padding: 4rem;
    text-align: right;
    /* border-top: 1px solid #e5e5e5; */
    border: none;
}
.modal-default-button {
  float: right;
}
.fs18{
  font-size: 4.8rem;
}
 .modal_body_title {
    color: #333333;
    font-family: PingFang SC;
    font-size: 6.4rem;
    font-weight: 500;
    line-height: 9.6rem;
    letter-spacing: 0px;
  }
  .modal_body_bg {
    margin-top: 2.6667rem;
    width: 50.6667rem;
    height: 40rem;
    background-image: url("~@/assets/images/orderInfo_bg.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius:4px;
    padding: 4.2667rem 6.4rem;
    box-sizing: border-box;
    color: #FFFFFF;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    &>div:nth-of-type(1) {
      font-size: 6.4rem;
    }
    &>div:nth-of-type(2) {
      font-size: 5.8667rem;
    }
    &>div:nth-of-type(3) {
      font-size: 4.2667rem;
    }
  }
  .modal_body_select {
    margin-top: 4.2667rem;
    select {
      width: 100%;
      height: 10.6667rem;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: flex-start;
      padding: 2.1333rem 4.2667rem;
      border: 1px solid #DDDDDD !important;
      border-radius:4px;
      font-size: 4.2667rem;
      font-weight: 400;
      border: none;
      color: #808DA1;
      vertical-align: middle;
      line-height: 100%;
      option {
        padding: 1.3333rem;
        border: 1px solid #DDDDDD;
      }
    }
    select:focus-visible {
        outline: none;
    }
  }
  .payment_money {
    color: #6696FF;
    margin-top: 4.2667rem;
    font-size: 5.3333rem;
    font-weight: 500;
    line-height: 8rem;
    .payment_money_detail {
      font-size: 3.2rem;
      font-weight: 400;
      line-height: 4.8rem;
      color: #666666;
      span {
        color: #E70000;
      }
    }
  }
  .payment_qr_box_content6 {
    display: flex;
    align-items: center;
    justify-content: space-around;
    text-align: center;
    margin-top: 2.6667rem;
    & > div{
      width: 26.6667rem;
      height: 10.6667rem;
      color: #FFFFFF;
      font-size: 4.2667rem;
      font-weight: 400;
      line-height: 10.6667rem;
      border-radius:4px;
      cursor: pointer;
    }
    & > div:nth-of-type(1) {
      background: #0069EA;
    }
    & > div:nth-of-type(2) {
      background: #0FC200;
    }
  }
  
  .to-back{
    display: flex;
    justify-content: flex-end;
    font-size: 4.8rem;
    color: rgb(128, 141, 161);
    margin-bottom: 3.2rem;
    cursor: pointer;
  }
  .has_order{
    font-size: 3.7333rem;
    margin-top: 2.6667rem;
    span{
      color: #6696FF;
      cursor: pointer;
    }
  }
 // 二维码块
  .payment_qr_box {
    text-align: center;
    font-size: 3.2rem;
    font-weight: 400;
    line-height: 4.8rem;
    color:#808DA1;
    .payment_qr_box_content1 {
      margin-bottom: 4.2667rem;
      color: #666666;
      span:nth-of-type(1) {
        font-size: 2.6667rem;
        font-weight: 500;
        color:#6696FF;
      }
      span:nth-of-type(2) {
        color:#E70000;
      }
    }
    .payment_qr_box_content4 {
        width: 58.6667rem;
        height: 58.6667rem;
        // border: 1px solid #f3f3f3;
        margin: 0 auto;
        img {
          width: 100%;
          height: 100%;
        }
    }
    .payment_qr_box_content5 {
      margin-bottom: 13.3333rem;
    }
    .payment_qr_box_content6 {
      display: flex;
      align-items: center;
      justify-content: space-around;
      & > div{
        width: 26.6667rem;
        height: 10.6667rem;
        color: #FFFFFF;
        font-size: 4.2667rem;
        font-weight: 400;
        line-height: 10.6667rem;
        border-radius:4px;
        cursor: pointer;
      }
      & > div:nth-of-type(1) {
        background: #0069EA;
      }
      & > div:nth-of-type(2) {
        background: #0FC200;
      }
    }
    .payment_qr_box_content7 {
      text-align: right;
      color: #6696FF;
      font-size: 4.8rem;
      font-weight: 400;
      line-height: 6.9333rem;
      margin-bottom: 4.2667rem;
      cursor: pointer;
    }
  }
}
</style>


